import moment from 'moment';

export const NOW = () => moment();
export const EMPTY_FUNCTION = () => {
};